import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { ClientService } from '../services/client/client.service';
import { ClientCustomization } from '../../types/client';

@Directive({
  selector: '[appIsEnabled]',
  standalone: true,
})
export class IsEnabledDirective implements OnInit {
  @Input('appIsEnabled') key!: keyof ClientCustomization | null;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private clientService: ClientService,
  ) {}

  ngOnInit(): void {
    const client = this.clientService.client;

    if (!this.key)  {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
    else if (!client.customizationsEnabled || client.customization?.[this.key]) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
